module.exports = __webpack_public_path__ + "img/ingenierieEtConseilPatrimoniaux_p1_img1.198e0ca4.png";